import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "toggle", "spinner"]

  async toggle(event) {
    const checkbox = event.target
    const url = checkbox.dataset.url
    const nowEnabled = checkbox.checked

    // Show loading state
    checkbox.disabled = true
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      const data = await response.json()

      if (data.status === 'success') {
        // Update card opacity without page reload
        const card = this.element.closest('[data-rotation-id]')
        if (card) {
          card.classList.toggle('opacity-50', !nowEnabled)
        }
        this.finishLoading(checkbox)
        this.showToast(data.message || (nowEnabled ? 'Roleta ativada' : 'Roleta desativada'), 'success')
      } else {
        this.resetState(checkbox)
        this.showToast(data.message || 'Erro ao atualizar roleta', 'error')
      }
    } catch (error) {
      this.resetState(checkbox)
      console.error('Error toggling rotation:', error)
      this.showToast('Erro ao atualizar roleta', 'error')
    }
  }

  finishLoading(checkbox) {
    checkbox.disabled = false
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('hidden')
    }
  }

  resetState(checkbox) {
    checkbox.checked = !checkbox.checked
    this.finishLoading(checkbox)
  }

  showToast(message, type = 'info') {
    document.querySelectorAll('.rotation-toast').forEach(t => t.remove())

    const toast = document.createElement('div')
    toast.className = `rotation-toast fixed bottom-4 right-4 px-4 py-3 rounded-lg shadow-lg z-[9999] flex items-center gap-2 transform translate-y-2 opacity-0 transition-all duration-300`

    if (type === 'success') {
      toast.classList.add('bg-green-600', 'text-white')
      toast.innerHTML = `
        <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <span class="font-medium">${message}</span>
      `
    } else {
      toast.classList.add('bg-red-600', 'text-white')
      toast.innerHTML = `
        <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
        <span class="font-medium">${message}</span>
      `
    }

    document.body.appendChild(toast)

    requestAnimationFrame(() => {
      toast.classList.remove('translate-y-2', 'opacity-0')
    })

    setTimeout(() => {
      toast.classList.add('translate-y-2', 'opacity-0')
      setTimeout(() => toast.remove(), 300)
    }, 3000)
  }
}
